import { applyPayloadExtraDocCreation, formatDate, generateErrorsExtraDoc } from 'utilities/util';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';
import { TYPES } from 'action-types/extraDocument';
import { callApiExtraDocument, callApiV3Get, callApiV3Post, callApiV3Put } from 'utilities/apiCaller';
import API from 'constants/api';
import { IExportExtraDocumentConfiguration, IExtraDocumentConfigurationListModel, IImportExtraDocumentConfiguration, IToggleActiveExtraDocumentConfiguration } from 'reducers/extraDocument/models';

export const searchExportExtraDocumentConfiguration = (pageNumber: number = 1, pageSize: number = 10) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.SEARCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING });
        try {
            const query: any = {
                Page: pageNumber,
                PageSize: pageSize,
                ...getState().filters.filters,
               
            };
            if (getState().filters.column) {
                query.SortOrder = getState().filters.order;
                query.SortColumn = getState().filters.column;
            }
            const res = await callApiV3Post(`${API.ExtraDocument.SearchExportExtraDocumentConfiguration}`, query);
            dispatch({ type: TYPES.SEARCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED, exportExtraDocumentConfigs: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.SEARCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED, errors });
        }
    }
};

export const searchImportExtraDocumentConfiguration = (pageNumber: number = 1, pageSize: number = 10) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.SEARCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING });
        try {
            const query: any = {
                Page: pageNumber,
                PageSize: pageSize,
                ...getState().filters.filters
            };
            if (getState().filters.column) {
                query.SortOrder = getState().filters.order;
                query.SortColumn = getState().filters.column;
            }
            const res = await callApiV3Post(`${API.ExtraDocument.SearchImportExtraDocumentConfiguration}`, query);
            dispatch({ type: TYPES.SEARCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED, importExtraDocumentConfigs: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.SEARCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED, errors });
        }
    }
};

export const fetchExportExtraDocumentConfigurationById = (itemData: IExtraDocumentConfigurationListModel) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.RESET_ERROR });
        dispatch({ type: TYPES.FETCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.PENDING });
        try {
            const res = await callApiV3Get(`${API.ExtraDocument.ExportExtraDocumentConfiguration}/${itemData.id}`);
            res.data.type = itemData.type;
            res.data.id = itemData.id;
            dispatch({ type: TYPES.FETCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.FULFILLED, exportExtraDocumentConfig: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.FETCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.REJECTED, errors });
        }
    }
};

export const resetExportExtraDocumentConfiguration = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.RESET_ERROR });
    }
}

export const addExportExtraDocumentConfiguration = (data: IExportExtraDocumentConfiguration) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.ADD_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING });
        try {
            const res = await callApiV3Post(`${API.ExtraDocument.ExportExtraDocumentConfiguration}/`, { ...data });
            dispatch({ type: TYPES.ADD_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED, addExportResponse: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.ADD_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED, errors });
        }
    }
};

export const updateExportExtraDocumentConfiguration = (data: IExportExtraDocumentConfiguration) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.UPDATE_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING });
        try {
            const res = await callApiV3Put(`${API.ExtraDocument.ExportExtraDocumentConfiguration}/${data.id}`, { ...data });
            dispatch({ type: TYPES.UPDATE_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED, updateExportResponse: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.UPDATE_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED, errors });
        }
    }
};

export const fetchImportExtraDocumentConfigurationById = (itemData: IExtraDocumentConfigurationListModel) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.RESET_ERROR });
        dispatch({ type: TYPES.FETCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.PENDING });
        try {
            const res = await callApiV3Get(`${API.ExtraDocument.ImportExtraDocumentConfiguration}/${itemData.id}`);
            res.data.type = itemData.type;
            res.data.id = itemData.id;
            dispatch({ type: TYPES.FETCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.FULFILLED, importExtraDocumentConfig: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.FETCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.REJECTED, errors });
        }
    }
};

export const resetImportExtraDocumentConfiguration = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.RESET_ERROR });
    }
}

export const addImportExtraDocumentConfiguration = (data: IImportExtraDocumentConfiguration) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.ADD_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING });
        try {
            const res = await callApiV3Post(`${API.ExtraDocument.ImportExtraDocumentConfiguration}/`, { ...data });
            dispatch({ type: TYPES.ADD_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED, addImportResponse: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.ADD_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED, errors });
        }
    }
};

export const updateImportExtraDocumentConfiguration = (data: IImportExtraDocumentConfiguration) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.UPDATE_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING });
        try {
            const res = await callApiV3Put(`${API.ExtraDocument.ImportExtraDocumentConfiguration}/${data.id}`, { ...data });
            dispatch({ type: TYPES.UPDATE_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED, updateImportResponse: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.UPDATE_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED, errors });
        }
    }
};

export const toggleActiveExtraDocumentConfiguration = (data: IToggleActiveExtraDocumentConfiguration) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.TOGGLE_ACTIVE_EXTRA_DOCUMENT_CONFIGURATION.PENDING });
        try {
            const res = await callApiV3Put(`${API.ExtraDocument.ExtraDocumentConfiguration}/${data.id}`, { ...data });
            dispatch({ type: TYPES.TOGGLE_ACTIVE_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED, toggleActiveResponse: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.TOGGLE_ACTIVE_EXTRA_DOCUMENT_CONFIGURATION.REJECTED, errors });
        }
    }
};

export const fetchEssoRates = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.FETCH_ESSO_RATES.PENDING });
        try {
            const query: any = {
                customerBeCode: getState().filters.filters.customerBeCode,
                startDate: getState().filters.filters.dateFrom ? formatDate(getState().filters.filters.dateFrom.toString(), 'YYYY-MM-DD'): ' ',
                endDate: getState().filters.filters.dateTo ? formatDate(getState().filters.filters.dateTo.toString(), 'YYYY-MM-DD'): ''
            };
            const res = await callApiV3Get(`${API.ExtraDocument.EssoRates}`, query,{});
            dispatch({ type: TYPES.FETCH_ESSO_RATES.FULFILLED, issorates: res });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.FETCH_ESSO_RATES.REJECTED, errors });
        }
    }
};

export const extraDocumentCreationImport = (page: number = 1, pageSize: number = 10, param: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.EXTRA_DOCUMENT_CREATION_IMPORT.PENDING });
        try {
            const res = await callApiExtraDocument(`${API.ExtraDocument.extraDocImport}`, applyPayloadExtraDocCreation(getState,
                {
                    isAirInFilters: false,
                    isAirInBody: false
                }, {
                    Page: page,
                    PageSize: pageSize,
                }, ...param), {});
            dispatch({ type: TYPES.EXTRA_DOCUMENT_CREATION_IMPORT.FULFILLED, extraDocumentCreationImport: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.EXTRA_DOCUMENT_CREATION_IMPORT.REJECTED, errors });
        }
    }
};

export const extraDocumentCreationExport = (page: number = 1, pageSize: number = 10, param: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.EXTRA_DOCUMENT_CREATION_EXPORT.PENDING });
        try {
            const res = await callApiV3Post(`${API.ExtraDocument.extraDocExport}`, applyPayloadExtraDocCreation(getState,
                {
                    isAirInFilters: false,
                    isAirInBody: false
                }, {
                    Page: page,
                    PageSize: pageSize,
                }, ...param), {});
            dispatch({ type: TYPES.EXTRA_DOCUMENT_CREATION_EXPORT.FULFILLED, extraDocumentCreationExport: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.EXTRA_DOCUMENT_CREATION_EXPORT.REJECTED, errors });
        }
    }
};

export const processExtraDocumentCreationImport = (param: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_IMPORT.PENDING });
        try {
            const res = await callApiExtraDocument(`${API.ExtraDocument.processExtraDocImport}`, ...param);
            dispatch({ type: TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_IMPORT.FULFILLED, processExtraDocumentCreationImportRes: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_IMPORT.REJECTED, errors });
        }
    }
};

export const processExtraDocumentCreationExport = (param: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_EXPORT.PENDING });
        try {
            const res = await callApiV3Post(`${API.ExtraDocument.processExtraDocExport}`, ...param);
            dispatch({ type: TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_EXPORT.FULFILLED, processExtraDocumentCreationExportRes: res.data });
        } catch (e) {
            const errors = generateErrorsExtraDoc(e);
            dispatch({ type: TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_EXPORT.REJECTED, errors });
        }
    }
};

